import { useState, useEffect } from 'react';
import { useContent } from '../../../content/ContentProvider';

export default function Header() {
  const content = useContent();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
    setMobileOpen(false);
  };

  const navLinks = content.global.navLinks;

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white border-b border-gray-100' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
          <div className="bg-white p-1.5 rounded-xl shadow-md border border-gray-150/50 flex items-center justify-center transition-all hover:scale-105 hover:shadow-lg duration-200">
            <img
              src={content.global.logo}
              alt={content.brand.fullName}
              className="h-11 md:h-14 w-auto object-contain"
            />
          </div>
          <div className="min-w-0">
            <div className={`text-base sm:text-lg font-bold transition-colors truncate ${scrolled ? 'text-gray-900' : 'text-white'}`} style={{ fontFamily: 'Inter, sans-serif' }}>
              {content.brand.name}
            </div>
            <div className={`hidden sm:block text-xs transition-colors whitespace-nowrap ${scrolled ? 'text-gray-500' : 'text-gray-200'}`}>
              Community Support Services
            </div>
          </div>
        </div>

        <nav className="hidden md:flex items-center gap-6">
          {navLinks.slice(0, -1).map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-gray-200 hover:text-white'}`}
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollToSection('get-help')}
            className="px-5 py-2 bg-teal-500 hover:bg-teal-600 text-white text-sm font-semibold rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            Get Help Now
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className={`px-5 py-2 border text-sm font-semibold rounded-full transition-colors cursor-pointer whitespace-nowrap ${scrolled ? 'border-gray-300 text-gray-700 hover:border-teal-500 hover:text-teal-600' : 'border-white/40 text-white hover:border-white'}`}
          >
            Contact
          </button>
        </nav>

        <button
          className={`md:hidden w-8 h-8 flex-shrink-0 flex items-center justify-center cursor-pointer ${scrolled ? 'text-gray-700' : 'text-white'}`}
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={`text-2xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 space-y-3">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-600 py-2 cursor-pointer"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollToSection('get-help')}
            className="w-full py-3 bg-teal-500 text-white font-semibold rounded-xl text-sm cursor-pointer whitespace-nowrap"
          >
            Get Help Now
          </button>
        </div>
      )}
    </header>
  );
}
